"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatStandardAddress = void 0;
const COMMA_SEPARATOR = ', ';
const SPACE_SEPARATOR = ' ';
const formatStandardAddress = ({ additionalInfo, streetType, street, state, city }) => {
    return [
        [[[streetType, street].filter(Boolean).join(SPACE_SEPARATOR).trim(), []].filter(Boolean).join(COMMA_SEPARATOR).trim()]
            .filter(Boolean)
            .join(COMMA_SEPARATOR)
            .trim(),
        [additionalInfo, []].filter(Boolean).join(COMMA_SEPARATOR).trim(),
        [city, [state].filter(Boolean).join(SPACE_SEPARATOR).trim()].filter(Boolean).join(COMMA_SEPARATOR).trim(),
    ].filter(Boolean);
};
exports.formatStandardAddress = formatStandardAddress;
//# sourceMappingURL=utils.js.map